<template>
  <div>
    <Track-Common
        :indent="indent"
        :fastTagTrackingEnabled="fastTagTrackingEnabled"
        :gpsTrackingEnabled="gpsTrackingEnabled"
        :isSimTrackingAllowed="isSimTrackingAllowed"
        :simTrackingEnabled="simTrackingEnabled"
        :yetToTruckIn="yetToTruckIn"
        :hasDriverAccepted="hasDriverAccepted"
        :appTrackingEnabled="appTrackingEnabled"
        :hyperTrackingEnabled="hyperTrackingEnabled"
        :yetToDispatch="yetToDispatch"
        :trackingAfterTruckOut="trackingAfterTruckOut"
        :isOrderLoading="isOrderLoading"
        :isShipper=true
        :isLoading="isLoading"
        :isMapLoading="isMapLoading"
        :showMap="showMap"
        :operator="operator"
        :consentStatus="consentStatus"
        :mapConfig="mapConfig"
        :environmentVariables="environmentVariables"
        :premiumSimTrackingEnabled="$hasFeature('detailed_track_view')"
        @getconsent="getconsent"
        @loadMap="loadMap"
        @manualEndTrip="manualEndTrip"
    />
  </div>
</template>
<script>
/* eslint-disable import/no-extraneous-dependencies */
import { mapGetters } from 'vuex';
import { TripErrors, LocationTracker } from 'pando-constants';
import Track from '@common/components/track';

export default {
  props: {
    indent: {
      type: Object,
      default: () => {},
    },
    fastTagTrackingEnabled: {
      type: Boolean,
      default: false,
    },
    gpsTrackingEnabled: {
      type: Boolean,
      default: false,
    },
    isSimTrackingAllowed: {
      type: Boolean,
      default: false,
    },
    simTrackingEnabled: {
      type: Boolean,
      default: false,
    },
    yetToTruckIn: {
      type: Boolean,
      default: false,
    },
    trackingAfterTruckOut: {
      type: Boolean,
      default: false,
    },
    hasDriverAccepted: {
      type: Boolean,
      default: false,
    },
    appTrackingEnabled: {
      type: Boolean,
      default: false,
    },
    hyperTrackingEnabled: {
      type: Boolean,
      default: false,
    },
    mapConfig: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      operator: '',
      isLoading: false,
      showMap: false,
      consentStatus: '',
      isMapLoading: false,
    };
  },
  components: {
    'Track-Common': Track,
  },
  computed: {
    ...mapGetters({
      isOrderLoading: 'order/isOrderLoading',
      environmentVariables: 'app/environmentVariables',
    }),
    yetToDispatch() {
      return this.indent.sources.every(source => source.dispatched_at === null);
    },
  },
  methods: {
    async getLocation() {
      try {
        this.isMapLoading = true;
        const result =
          await this.$store.dispatch('order/location', { orderNo: this.indent.order_number }) || {};
        result.mapSettings = this.environmentVariables && this.environmentVariables.map_settings;
        this.data = result;
        this.$session.set('mapData', result);
        this.isMapLoading = false;
      } catch (err) {
        this.$error({ message: this.$t('INDENT_LOAD_MAP_ERROR_MSG') });
      }
    },
    async getconsent(phone, tripId) {
      try {
        if (tripId) {
          this.isLoading = true;
          const errorMsg = this.indent.track_error;
          if (!errorMsg || errorMsg === TripErrors.LOCATION_NOT_AVAILABLE) {
            await this.getLocation(tripId);
            this.showMap = true;
          } else if (errorMsg === TripErrors.OPERATOR_NOT_SUPPORTED) {
            this.consentStatus = LocationTracker.INVALID_TRIP;
          } else if (errorMsg === TripErrors.CONSENT_NOT_RECEIVED) {
            this.consentStatus = LocationTracker.PENDING_TRIP;
          } else {
            const result = await this.$store.dispatch('order/getconsent', { phone });
            this.consentStatus = this.indent.flow.app_tracking
              && this.indent.flow.app_tracking.track_trip_id ?
              true : result.status;
            this.operator = result.operator;
          }
        } else {
          this.consentStatus = this.$t('INDENT_TRIP_ID_NOT_AVAILABLE');
        }
        this.isLoading = false;
      } catch (err) {
        this.isLoading = false;
        this.$error({ message: this.$t('INDENT_LOAD_MAP_ERROR_MSG') });
      }
    },
    async loadMap(tripId) {
      try {
        if (tripId) {
          this.isLoading = true;
          await this.getLocation(tripId);
          this.showMap = true;
        }
        this.isLoading = false;
      } catch (err) {
        this.isLoading = false;
        this.$errorMessage({ message: this.$t('INDENT_LOAD_MAP_FAILED') });
      }
    },
    async manualEndTrip() {
      try {
        const result = await this.$store.dispatch('order/manualEndTrip', { order: this.indent });
        if (result && result.status === 204) {
          this.$successMessage({ message: 'The Trip Has Been Manually Ended' });
        }
      } catch (err) {
        this.$errorMessage({ message: 'Unable to manually end trip' });
      }
    },
  },
};
</script>
